import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.scss'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import Tabs from 'srcReact/components/common2/Tabs'
import { mixrActions } from 'srcReact/Mixr/actions'
import { useTranslation } from 'react-i18next'
import MembersTabContent from 'srcReact/components/common2/MembersTabContent'
import { checkNested } from 'srcReact/helpers/validator'

const Members = ({ mixrId, selectedScope, isStatic }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [pagination, setPagination] = useState({ nextOffset: 0, isPagination: false })
  const [members, setMembers] = useState([])
  const [scope, setScope] = useState('participants')
  const [activeTab, setActiveTab] = useState(0)

  const {
    login: { user: loggedInUser },
    workplace: { current_workplace },
    mixr: { mixr, membersLoading, searchedMemberError, users, usersStat, userAfterChangedRole }
  } = useSelector((state) => state)

  useEffect(() => {
    setMembers([...users])
  }, [scope, users])

  useEffect(() => {
    if (selectedScope === 'staff') {
      setScope('staff')
      setActiveTab(1)
    }
  }, [selectedScope])

  const lastMemberRef = useInfinitScroll(
    membersLoading,
    usersStat && usersStat.remaining,
    usersStat && usersStat.next_offset,
    setPagination,
    [membersLoading]
  )

  const getMembers = (attendingType, searchValue, order) => {
    if (!isStatic) {
      dispatch(mixrActions.getParticipants(mixrId, scope, attendingType, pagination, searchValue, order))
    }
  }

  const showParticipants = () => {
    setPagination({ nextOffset: 0, isPagination: false })
    setScope('participants')
    setActiveTab(0)
  }

  const showOrganizers = () => {
    setPagination({ nextOffset: 0, isPagination: false })
    setScope('staff')
    setActiveTab(1)
  }

  const showInvites = () => {
    setScope('invited_all')
    setActiveTab(2)
  }

  const isLoggedInUserOrganizer = () => {
    if (mixr && mixr.logged_user) {
      return mixr.logged_user.mixr_role === 'organizer'
    }
    return false
  }

  const handleAddCoorganizer = (userId) => {
    if (mixr) {
      dispatch(mixrActions.addStaffRole(mixrId, userId, 'co-organizer'))
    }
  }
  const handleRemoveCoorganizer = (userId) => {
    if (mixr) {
      dispatch(mixrActions.removeStaffRole(mixrId, userId, scope))
    }
  }

  return (
    <div className={styles.membersWrapper}>
      <MembersTabContent
        type='mixr'
        scope={scope}
        members={members}
        participants={mixr && mixr.participants}
        pagination={pagination}
        setPagination={setPagination}
        membersLoading={membersLoading}
        searchedMemberError={searchedMemberError}
        lastMemberRef={lastMemberRef}
        current_workplace={current_workplace}
        getMembers={getMembers}
        isOrganizer={isLoggedInUserOrganizer()}
        loggedInUser={loggedInUser}
        handleAddCoorganizer={handleAddCoorganizer}
        handleRemoveCoorganizer={handleRemoveCoorganizer}
        userAfterRoleChanged={userAfterChangedRole}
        isMixrOver={mixr && mixr.status === 'over'}
        isHybridMixr={mixr && mixr.attending_type === 'both'}
        setScope={setScope}
      />
    </div>
  )
}

export default Members
